export const ReservedSearchParams = new Set([
    "search",  // search term
    "page",    // pagination
    "cursor",  // cursor pagination (if you add it later)
    "sort",    // optional
    "limit",   // optional
    "loaded",
    "restore",
    "tags",    // tag filters (e.g. "New Items"); resolved server-side to Cosmos-defined
               // predicates. Reserved so it's not mistaken for a product-attribute filter.
    "from"  // legacy breadcrumb-context flag, no longer set; kept reserved so any
            // lingering ?from=all link is ignored rather than treated as a filter
]);